// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Example theme */
.msts_theme_example {
  border: 1px solid silver;
}
.msts_theme_example .msts__heading .msts__side {
  padding: 5px;
  text-align: center;
  color: #fff;
  font-weight: bold;
}
.msts_theme_example .msts__heading .msts__side_available {
  background-color: rgb(0, 193, 121);
  border-right: 3px solid;
}
.msts_theme_example .msts__heading .msts__side_selected {
  border-left: 3px solid;
  background-color: rgb(0, 193, 121);
}
.msts_theme_example .msts__subheading .msts__side_filter {
  padding: 5px;
}
.msts_theme_example .msts__footer .msts__side {
  padding: 5px 15px;
  background-color: #ecf0f1;
  font-size: 0.75em;
  color: #7f8c8d;
  text-align: right;
}
.msts_theme_example .msts__list {
  height: 140px;
  overflow-y: auto;
  overflow-x: hidden;
}
.msts_theme_example .msts__list-item {
  padding: 5px 10px;
  transition: background-color ease-in 0.1s, color ease-in 0.1s;
}
.msts_theme_example .msts__list-item:hover {
  background-color: #2980b9;
  color: #fff;
}
.msts_theme_example .msts__list-item_disabled {
  background-color: #ecf0f1;
  color: #7f8c8d;
}
.msts_theme_example .msts__list-item_disabled:hover {
  background-color: #ecf0f1;
  color: #7f8c8d;
}
.msts_theme_example .msts__list-item_highlighted {
  background-color: rgba(41, 128, 185, 0.25);
}
.msts_theme_example .msts__control {
  border: none;
  background: none;
  cursor: pointer;
  padding: 10px 3px;
  color: #bdc3c7;
  transition: color ease 0.15s;
}
.msts_theme_example .msts__control:hover {
  color: #95a5a6;
}
.msts_theme_example .msts__control[disabled] {
  color: #ecf0f1;
}
.msts_theme_example .msts__control_select-all:after {
  content: "❯";
}
.msts_theme_example .msts__control_deselect-all:after {
  content: "❮";
}
.msts_theme_example .msts__filter {
  position: relative;
}
.msts_theme_example .msts__filter-input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  border: 1px solid silver;
}
.msts_theme_example .msts__filter-clear {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  padding: 0 10px;
  font-size: 1.25em;
  color: silver;
  transition: color ease 0.15s;
}
.msts_theme_example .msts__filter-clear:after {
  content: "×";
  vertical-align: middle;
}
.msts_theme_example .msts__filter-clear:hover {
  color: #c0392b;
}

.msts_theme_example.msts_disabled {
  background-color: #ecf0f1;
}

button.msts__control.msts__control_select-all,
button.msts__control.msts__control_deselect-all {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/userDetail/Components/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kBAAA;AACA;EACC,wBAAA;AAED;AACE;EACC,YAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AACH;AAEE;EACC,kCAAA;EACA,uBAAA;AAAH;AAGE;EACC,sBAAA;EACA,kCAAA;AADH;AAME;EACC,YAAA;AAJH;AASE;EACC,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAPH;AAWC;EACC,aAAA;EACA,gBAAA;EACA,kBAAA;AATF;AAYC;EACC,iBAAA;EACA,6DAAA;AAVF;AAYE;EACC,yBAAA;EACA,WAAA;AAVH;AAaE;EACC,yBAAA;EACA,cAAA;AAXH;AAaG;EACC,yBAAA;EACA,cAAA;AAXJ;AAeE;EACC,0CAAA;AAbH;AAiBC;EACC,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,4BAAA;AAfF;AAiBE;EACC,cAAA;AAfH;AAkBE;EACC,cAAA;AAhBH;AAqBE;EACC,YAAA;AAnBH;AAwBE;EACC,YAAA;AAtBH;AA0BC;EACC,kBAAA;AAxBF;AA2BC;EACC,WAAA;EACA,sBAAA;EACA,YAAA;EACA,wBAAA;AAzBF;AA4BC;EACC,eAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,4BAAA;AA1BF;AA4BE;EACC,YAAA;EACA,sBAAA;AA1BH;AA6BE;EACC,cAAA;AA3BH;;AAgCA;EACC,yBAAA;AA7BD;;AA+BA;;EAGC,aAAA;AA7BD","sourcesContent":["/* Example theme */\n.msts_theme_example {\n\tborder: 1px solid silver;\n\n\t.msts__heading {\n\t\t.msts__side {\n\t\t\tpadding: 5px;\n\t\t\ttext-align: center;\n\t\t\tcolor: #fff;\n\t\t\tfont-weight: bold;\n\t\t}\n\n\t\t.msts__side_available {\n\t\t\tbackground-color:rgb(0, 193, 121);\n\t\t\tborder-right: 3px solid;\n\t\t}\n\n\t\t.msts__side_selected {\n\t\t\tborder-left: 3px solid;\n\t\t\tbackground-color: rgb(0, 193, 121);\n\t\t}\n\t}\n\n\t.msts__subheading {\n\t\t.msts__side_filter {\n\t\t\tpadding: 5px;\n\t\t}\n\t}\n\n\t.msts__footer {\n\t\t.msts__side {\n\t\t\tpadding: 5px 15px;\n\t\t\tbackground-color: #ecf0f1;\n\t\t\tfont-size: 0.75em;\n\t\t\tcolor: #7f8c8d;\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t.msts__list {\n\t\theight: 140px;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t}\n\n\t.msts__list-item {\n\t\tpadding: 5px 10px;\n\t\ttransition: background-color ease-in 0.1s, color ease-in 0.1s;\n\n\t\t&:hover {\n\t\t\tbackground-color: #2980b9;\n\t\t\tcolor: #fff;\n\t\t}\n\n\t\t&_disabled {\n\t\t\tbackground-color: #ecf0f1;\n\t\t\tcolor: #7f8c8d;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: #ecf0f1;\n\t\t\t\tcolor: #7f8c8d;\n\t\t\t}\n\t\t}\n\n\t\t&_highlighted {\n\t\t\tbackground-color: rgba(41, 128, 185, 0.25);\n\t\t}\n\t}\n\n\t.msts__control {\n\t\tborder: none;\n\t\tbackground: none;\n\t\tcursor: pointer;\n\t\tpadding: 10px 3px;\n\t\tcolor: #bdc3c7;\n\t\ttransition: color ease 0.15s;\n\n\t\t&:hover {\n\t\t\tcolor: #95a5a6;\n\t\t}\n\n\t\t&[disabled] {\n\t\t\tcolor: #ecf0f1;\n\t\t}\n\t}\n\n\t.msts__control_select-all {\n\t\t&:after {\n\t\t\tcontent: '❯';\n\t\t}\n\t}\n\n\t.msts__control_deselect-all {\n\t\t&:after {\n\t\t\tcontent: '❮';\n\t\t}\n\t}\n\n\t.msts__filter {\n\t\tposition: relative;\n\t}\n\n\t.msts__filter-input {\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t\tpadding: 5px;\n\t\tborder: 1px solid silver;\n\t}\n\n\t.msts__filter-clear {\n\t\tcursor: pointer;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\theight: 100%;\n\t\tpadding: 0 10px;\n\t\tfont-size: 1.25em;\n\t\tcolor: silver;\n\t\ttransition: color ease 0.15s;\n\n\t\t&:after {\n\t\t\tcontent: '×';\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t&:hover {\n\t\t\tcolor: #c0392b;\n\t\t}\n\t}\n}\n\n.msts_theme_example.msts_disabled {\n\tbackground-color: #ecf0f1;\n}\nbutton.msts__control.msts__control_select-all,\nbutton.msts__control.msts__control_deselect-all\n {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
